import Letter from './letter';

const Attempt = ({ attempt, attemptIndex, result, currentAttemptIndex, currentLetterIndex, attemptClass, currentAttemptClass, animateIndex, readOnly, placeholder }) => {
  const active = attemptIndex === currentAttemptIndex;
  const animate = animateIndex < attemptIndex;
  return (
    <div className={`grid gap-2 select-none ${attemptClass} ${active ? [...currentAttemptClass].join(' ') : ''}`}>
      {
        attempt.map((letter, letterIndex) => (
          <Letter
            key={`attempt-${attemptIndex}-letter-${letterIndex}`}
            index={letterIndex}
            currentLetterIndex={currentLetterIndex}
            value={letter}
            result={result[letterIndex]}
            active={active}
            animate={animate}
            readOnly={readOnly}
            placeholder={active && placeholder[letterIndex]}
          />
        ))
      }
    </div>
  )
}

export default Attempt;
